const TOGGLE_MENU = 'app/TOGGLE_MENU';
const SET_LOADING = 'app/SET_LOADING';
const SET_IS_MOBILE = 'app/SET_IS_MOBILE';

export default {
  TOGGLE_MENU,
  SET_LOADING,
  SET_IS_MOBILE,
};
